import {Component, OnInit, ViewChild}   from '@angular/core';
import {ModalController, NavController} from '@ionic/angular';
import {DataStore, SortDirection}       from '@aws-amplify/datastore';
import {Router}                         from '@angular/router';
import {SessionService}                 from '../../services/session.service';
import {Contract}                       from '../../../models';
import {ContractsComponent}             from '../../components/lists/contracts/contracts.component';
import {ModalService}                   from "../../services/modal.service";


@Component({
    selector: 'app-contracts',
    templateUrl: './contracts.page.html',
    styleUrls: ['./contracts.page.scss'],
})
export class ContractsPage implements OnInit {

    @ViewChild('contractsListCmp') contractsListCmp: ContractsComponent;
    contractsList: Contract[] = [];
    cssClass: string;
    showFilters = false;
    sortAscendent = SortDirection.ASCENDING;
    sort = SortDirection;
    p;
    filters = {
        name: '',
        sort: this.sortAscendent,
        filterBy: 'startDate',
    };

    constructor(
            private modalService: ModalService,
            private router: Router,
            private navController: NavController,
            public sessionService: SessionService,
            private modalController: ModalController,
    ) {
    }

    ngOnInit() {
        // this.p = Percentages;
    }

    ionViewDidEnter() {
        // make sure the newly styled content scrolls when needed
        document.querySelectorAll('.main-content')[document.querySelectorAll('.main-content').length - 1].shadowRoot.querySelector('.inner-scroll').setAttribute('style', 'height:100%');
    }

    // ionViewDidEnter() {
    //     this.refreshContractList();
    // }

    // private async refreshContractList() {        
    //     const currentUser = this.sessionService.getCurrentUser();
    //     
    //     // this.contractsList = (await DataStore.query(Contract)).filter(c => c.addedBy?.id == currentUser?.id) || [];
    //     // this.contractsList = await DataStore.query(Contract);
    //     this.contractsList =  (await DataStore.query(Contract)).filter(c => c.clientId == currentUser?.id);
    //     

    //     // this.applyClassBySelection('bounceInRight');
    // }


    // // @todo
    // openContract(contractId: string) {
    //     this.cssClass = '';
    //     this.router.navigate(['/contract', contractId]);
    // }

    // editContract(contractId: string) {
    //     this.openEditContractModal(contractId);
    // }

    // addContract() {
    //     this.openEditContractModal(null);
    // }

    // private async openEditContractModal(contractId: any) {
    //     const modal = await this.modalController.create({
    //         component: EditContractPage,
    //         componentProps: {contractId: contractId},
    //         cssClass: 'custom-modal',
    //     });
    //     await modal.present();
    //     await modal.onWillDismiss().then(data => {
    //         this.refreshContractList();
    //     })
    // }

    // async deleteContract(contractId: string) {
    //     this.cssClass = '';

    //     if (confirm("Do you really want to delete this Contract")) {
    //         await DataStore.delete(Contract, contractId);
    //         // let the animation finish its job
    //         setTimeout(() => {
    //             this.refreshContractList();
    //         }, 1000);
    //     }
    // }
    profile = 'client';
    scadenza: any;

    back() {
        this.navController.back();
    }

    openPage(page: string) {
        return this.router.navigate([page]);
    }

    applyClassBySelection(effect: string): void {
        this.cssClass = 'animated ' + effect;
    }

    async filterContracts() {
        this.filters.sort = this.sortAscendent;

        await this.contractsListCmp.filterContracts(this.filters);
    }

    changeSort() {
        this.sortAscendent === SortDirection.ASCENDING ? this.sortAscendent = SortDirection.DESCENDING : this.sortAscendent = SortDirection.ASCENDING;
        this.filterContracts();
    }
}
